import type {BasePlaces} from "../../firebase/index.js";
import PlaceList from "./PlaceList.jsx";


export interface ItineraryUnassignedProps {
	  basePlaces: BasePlaces;
}
export default function ItineraryUnassigned({basePlaces}: ItineraryUnassignedProps) {
	  return (
				 <>
						<PlaceList basePlaces={basePlaces}/>
				 </>
	  );
}